// DEMO investor/partner profiles — placeholders only. These do NOT represent
// real companies, investors or investments in DtOrbit.
//
// TO ADD A REAL INVESTOR: set placeholder to false, fill name/type/description,
// drop the logo file into /app/frontend/public/assets/investors/ and set
// logo to "/assets/investors/<filename>", then add website, category and
// investmentDetails. The "Demo Profile" badge and placeholders disappear
// automatically — no UI changes needed.

export const INVESTORS = [
    {
        id: 1,
        placeholder: true,
        name: "Sameer Khanna",
        type: "Strategic Investor",
        logo: null,
        photo: "/assets/investors/sameer-khanna.webp",
        description:
            "Seasoned investor with 20+ years of experience in financial services and emerging technologies.",
        expertise: ["Finance", "Strategy"],
        website: null,
        category: "Digital Finance & Technology",
        investmentDetails: "Details to be announced",
    },
    {
        id: 2,
        placeholder: true,
        name: "Aamir Siddiqui",
        type: "Growth Investor",
        logo: null,
        photo: "/assets/investors/aamir-siddiqui.webp",
        description:
            "Focuses on high-growth fintech startups and scalable digital asset infrastructure.",
        expertise: ["Fintech", "Digital Assets"],
        website: null,
        category: "Fintech & Digital Assets",
        investmentDetails: "Details to be announced",
    },
    {
        id: 3,
        placeholder: true,
        name: "Vikram Malhotra",
        type: "Technology Investor",
        logo: null,
        photo: "/assets/investors/vikram-malhotra.webp",
        description:
            "Technology enthusiast investing in blockchain, AI, and next-generation platforms.",
        expertise: ["Blockchain", "AI"],
        website: null,
        category: "Blockchain Infrastructure",
        investmentDetails: "Details to be announced",
    },
    {
        id: 4,
        placeholder: true,
        name: "Farhan Qureshi",
        type: "Strategic Partner",
        logo: null,
        photo: "/assets/investors/farhan-qureshi.webp",
        description:
            "Expert in digital payments and cross-border financial solutions with global market exposure.",
        expertise: ["Payments", "Fintech"],
        website: null,
        category: "Digital Payments",
        investmentDetails: "Details to be announced",
    },
    {
        id: 5,
        placeholder: true,
        name: "Daniel Morgan",
        type: "Institutional Investor",
        logo: null,
        photo: "/assets/investors/daniel-morgan.webp",
        description:
            "Institutional investor specializing in financial technology and digital transformation.",
        expertise: ["Institutional", "Fintech"],
        website: null,
        category: "Financial Technology",
        investmentDetails: "Details to be announced",
    },
    {
        id: 6,
        placeholder: true,
        name: "Michael Anderson",
        type: "Technology Partner",
        logo: null,
        photo: "/assets/investors/michael-anderson.webp",
        description:
            "Global technology leader supporting innovative platforms and scalable infrastructure.",
        expertise: ["Technology", "Infrastructure"],
        website: null,
        category: "Digital Infrastructure",
        investmentDetails: "Details to be announced",
    },
];

export const PARTNERSHIP_FOCUS = [
    {
        icon: "Landmark",
        title: "Digital Finance",
        desc: "Building the bridge between digital assets and everyday finance for Indian users.",
    },
    {
        icon: "Network",
        title: "Blockchain Infrastructure",
        desc: "Dependable on-chain transaction handling across supported networks.",
    },
    {
        icon: "ArrowLeftRight",
        title: "USDT to INR Exchange",
        desc: "A live, focused product serving a clear and recurring exchange need.",
    },
    {
        icon: "Cpu",
        title: "Financial Technology",
        desc: "Live rate feeds, automated processing and reliable exchange infrastructure.",
    },
    {
        icon: "Lightbulb",
        title: "Product Innovation",
        desc: "Continuously improving the exchange experience — simpler, clearer, faster.",
    },
    {
        icon: "Layers",
        title: "Scalable Technology",
        desc: "Architecture designed to scale across volumes, markets and future ventures.",
    },
];

export const WHY_PARTNER = [
    {
        icon: "Cpu",
        title: "Technology First",
        desc: "An engineering-led platform where product quality and reliability come before everything else.",
    },
    {
        icon: "Layers",
        title: "Scalable Infrastructure",
        desc: "Systems designed to grow with demand — from live rates to transaction processing.",
    },
    {
        icon: "Smartphone",
        title: "Digital-First Experience",
        desc: "A fully digital product journey, built for how modern users actually exchange.",
    },
    {
        icon: "Telescope",
        title: "Long-Term Vision",
        desc: "We build for durability — partnerships and products meant to compound over years.",
    },
    {
        icon: "ShieldCheck",
        title: "Security & Reliability",
        desc: "Security-minded processing and transparent exchange flows at the core of the platform.",
    },
    {
        icon: "Globe",
        title: "Market Opportunity",
        desc: "Growing demand for straightforward digital asset conversion in India and beyond.",
    },
];

export const INVESTOR_METRICS = [
    { label: "Technology-led", caption: "Engineering-first platform development" },
    { label: "Growth-focused", caption: "Building for long-term expansion" },
    { label: "Scalable infrastructure", caption: "Designed to grow with demand" },
    { label: "Digital-first", caption: "Fully digital product experience" },
    { label: "Customer-centric", caption: "Every decision measured against user value" },
];
